<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import videoLow from '@/assets/main/video-low.mp4'
import second from '@/assets/show/image-1.webp'
import third from '@/assets/show/image-2.webp'
import four from '@/assets/show/image-3.webp'
import first from '@/assets/show/image.webp'
import Details from '@/components/shared/workshops/Details.vue'
import Localization from '@/components/shared/workshops/Localization.vue'
import Tickets from '@/components/shared/workshops/Tickets.vue'
import WorkshopHeaderInfo from '@/components/shared/workshops/WorkshopHeaderInfo.vue'
import WorkshopMedia from '@/components/shared/workshops/WorkshopMedia.vue'
import Faq from '../workshops/Faq.vue'

defineProps<{
    workshops: Workshop[]
}>()
</script>
<template>
    <section class="relative z-30 container mx-auto p-0! md:p-4!">
        <div class="relative z-0 container mx-auto overflow-hidden rounded-[20px] p-4 py-8 md:p-8" v-for="workshop in workshops" :key="workshop.id">
            <!-- Background Video -->
            <video
                class="pointer-events-none absolute inset-0 -z-10 h-[370px] w-full max-w-[380px] rounded-2xl object-cover"
                autoplay
                muted
                loop
                playsinline
                controlsList="nofullscreen"
                :controls="false"
                preload="none"
            >
                <source :src="videoLow" type="video/mp4" />
            </video>
            <div class="absolute inset-0 z-0 h-full w-full bg-[#0D1011]/80 backdrop-blur-[250px] md:p-8"></div>

            <!-- Main Content -->
            <div class="relative z-20 flex flex-col-reverse gap-6 md:flex-row lg:gap-12">
                <WorkshopMedia :show-gallery="false" />

                <WorkshopHeaderInfo :workshop="workshop" :show-buttoin-details="true">
                    <template #gallery>
                        <div class="grid grid-cols-4 gap-2 sm:gap-4">
                            <img :src="first" alt="Event image 1" class="aspect-square h-full w-full rounded-2xl object-cover" />
                            <img :src="second" alt="Event image 2" class="aspect-square h-full w-full rounded-2xl object-cover" />
                            <img :src="third" alt="Event image 3" class="aspect-square h-full w-full rounded-2xl object-cover" />
                            <img :src="four" alt="Event image 4" class="aspect-square h-full w-full rounded-2xl object-cover" />
                        </div>
                    </template>
                </WorkshopHeaderInfo>
            </div>


            <Details :workshop="workshop" />
            <hr class="mt-8 w-full border-slate-800 pb-12" />
            <Localization :workshop="workshop" />
            
            <Tickets :tickets="workshop.tickets" :workshop="workshop" v-if="workshop.tickets?.length" />


            <Faq />
        </div>
    </section>
</template>
